import Vue from 'vue'
//import App from 'App.vue'
import VueRouter from 'vue-router'
import auth from '@/auth'
import Accueil from '@/views/Accueil'
import Information from '@/views/Information'
import Sujet from '@/views/Sujet'
import DemandePrix from '@/views/DemandePrix'
import Services from '@/views/Services'
import ContactezNous from '@/views/ContactezNous'
import Secteur from '@/views/Secteur'
import Faq from '@/views/Faq'
import Evenements from '@/views/Evenements'
import AdminLogin from '@/views/admin/Authentification'
import AdminLogout from '@/views/admin/Deconnexion'
import AdminHome from '@/views/admin/Accueil'
import AdminClients from '@/views/admin/Clients'
import AdminContracts from '@/views/admin/Contracts'
import AdminContractsRange from '@/views/admin/ContractsRange'
import AdminContract from '@/views/admin/Contract'
import AdminInvoice from '@/views/admin/Invoice'
import AdminStaticIncludes from '@/views/admin/_StaticIncludes'
import AdminEvents from '@/views/admin/Evenements'
import AdminDeposits from '@/views/admin/Depots'
import AdminRapports from '@/views/admin/Rapports'

Vue.use(VueRouter)

VueRouter.prototype.open = function (routeObject) {
  const { href } = this.resolve(routeObject)
  window.open(href, '_blank')
}

export var router = new VueRouter({
  mode: 'history',
  routes: [

    //Public sections
    { path: '/', name: 'Accueil', component: Accueil },
    { path: '/Information', name: 'Information', component: Information },
    { path: '/sujet', name: 'Sujet', component: Sujet },
    { path: '/demandeprix', name: 'DemandePrix', component: DemandePrix },
    { path: '/services', name: 'Services', component: Services },
    { path: '/contacteznous', name: 'ContactezNous', component: ContactezNous },
    { path: '/secteur', name: 'Secteur', component: Secteur },
    { path: '/faq', name: 'Faq', component: Faq },
    { path: '/evenements', name: 'Evenements', component: Evenements },

    //Admin sections
    { path: '/admin/authentification', name: 'AdminLogin', component: AdminLogin },
    { path: '/admin/deconnexion', name: 'AdminLogout', component: AdminLogout },
    { path: '/admin/accueil', name: 'AdminHome', component: AdminHome, meta: { requiresAuth: true } },
    { path: '/admin/clients', name: 'AdminClients', component: AdminClients, meta: { requiresAuth: true } },
    { path: '/admin/contracts', name: 'AdminContracts', component: AdminContracts, meta: { requiresAuth: true } },
    { path: '/admin/contractsrange/:START', name: 'AdminContractsRange', component: AdminContractsRange, meta: { requiresAuth: true } },
    { path: '/admin/contract/:ID', name: 'AdminContract', component: AdminContract, meta: { requiresAuth: true } },
    { path: '/admin/invoice/:ID', name: 'AdminInvoice', component: AdminInvoice, meta: { requiresAuth: true } },
    { path: '/admin/staticIncludes', name: 'AdminStaticIncludes', component: AdminStaticIncludes, meta: { requiresAuth: true } },
    { path: '/admin/evenements', name: 'AdminEvents', component: AdminEvents, meta: { requiresAuth: true } },
    { path: '/admin/depots', name: 'AdminDeposits', component: AdminDeposits, meta: { requiresAuth: true } },
    { path: '/admin/rapports', name: 'AdminRapports', component: AdminRapports, meta: { requiresAuth: true } }
  ]
})

// router.redirect({
//   '*': '/home'
// })

//router.start(App, '#app')

// const router = new Router({
//   mode: 'history',
//   routes: [

//     //Public sections
//     { path: '/', name: 'Accueil', component: Accueil },
//     { path: '/flotte', name: 'Flotte', component: Flotte },
//     { path: '/sujet', name: 'Sujet', component: Sujet },
//     { path: '/demandeprix', name: 'DemandePrix', component: DemandePrix },
//     { path: '/services', name: 'Services', component: Services },
//     { path: '/contacteznous', name: 'ContactezNous', component: ContactezNous },
//     { path: '/secteur', name: 'Secteur', component: Secteur },
//     { path: '/faq', name: 'Faq', component: Faq },

//     //Admin sections
//     { path: '/admin/login', name: 'AdminLogin', component: AdminLogin },
//     { path: '/admin/home', name: 'AdminHome', component: AdminHome, meta: { requiresAuth: true } }
//   ]
// })

router.beforeEach((to, from, next) => {
  //alert(from.fullPath)
  //alert(to.fullPath)
  // alert(to.meta.requiresAuth)

  // alert(auth.user.name);
  //alert(auth.user.authenticated);
  //alert("redirect:" + auth.pageredirect)
  if (to.meta.requiresAuth) {
    if (auth.user.authenticated) {
      // if authenticated allow access
      next()
    } else if (!auth.user.authenticated) {
      //router.app.$auth.login() // trigger auth0's login.
      //router.go("/admin/login")
      next('/admin/authentification')
    }
  }
  else {
    next()
    //router.go("/")
  }
})

// Redirect to the home route if any routes are unmatched
// router.redirect({
//   '*': '/home'
// })

//export default router



// WEBPACK FOOTER //
// ./src/router/index.js